// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__35Qhe","range":"MonthRangeSwitch_range__1mvCO","disabled":"MonthRangeSwitch_disabled__jYUZ1"};